import { AfterContentInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { IncomesService } from 'src/app/shared/services/incomes/incomes.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { ProductLoaderService } from 'src/app/shared/services/product-loader/product-loader.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';

import { OpEnum } from '../../../shared/enums/op.enum';
import { CityModel, HousingTypeModel } from '../../../shared/models/abre-cuentas.model';
import { ContactModel } from '../../../shared/models/contact.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { StringHelperService } from '../../../shared/services/helpers/string-helper.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';

@Component({
  selector: 'app-form-ubication-info',
  templateUrl: './form-ubication-info.component.html',
  styleUrls: ['./form-ubication-info.component.scss'],
})
export class FormUbicationInfoComponent implements OnInit, AfterContentInit {

  formGroup: FormGroup;
  options: [any];
  optionsHousingType: [any];
  optionsStratum: [any];
  selectedCity: CityModel;
  selectedStratum: string;
  selectedHousingType: HousingTypeModel;
  contactInfo: ContactModel;
  showFields = false;
  has_second_headline: any;
  selectedOccupation: any;
  district_option: any;
  selected_district: any;
  city_option: any;

  /**
   * Summary Initialize Services
   * @param formBuilder
   * @param abreCuentasNavigationService
   * @param parametersService
   * @param appService
   * @param abreCuentasService
   */
  constructor(
    public copyService: CopyService,
    private formBuilder: FormBuilder,
    private navigationService: NavigationService,
    private stringHelperService: StringHelperService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private headerService: HeaderService,
    private captureService: CaptureService,
    private incomesService: IncomesService,
    private validationHelperService: ValidationHelperService,
    private requestService: RequestService) {

    this.headerService.show(true, true, true);
    this.district_option = this.abreCuentasService.getDistricts();
    this.formGroup = this.formBuilder.group({});
  }

  /**
   * Summary Charge data for contact and set in false Selected Option
   */
  ngOnInit() {
    this.selectedOccupation = this.abreCuentasService.getOccupationSelected();
    this.has_second_headline = this.abreCuentasService.getSecondHeadline();
    const productSelected = this.abreCuentasService.getproductSelected();
    if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
      productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
      productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING ||
      productSelected.product_type === BUSINESS_CONST.MULTI ||
      productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
      this.optionsHousingType = this.parametersService.getSetting(OpEnum.HOUSING_TYPE);
      this.optionsStratum = this.parametersService.getSetting(OpEnum.STRATUM);
      this.showFields = true;
      this.formGroup = new FormGroup({
        'input-value-address': new FormControl('',
          [Validators.required, Validators.minLength(4), Validators.maxLength(40), Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/))]),
        'input-value-addressDetail': new FormControl(''),
        'housing-selection': new FormControl('', Validators.required),
        'stratum-selection': new FormControl('', Validators.required),
      });
    } else {
      this.formGroup = new FormGroup({
        'input-value-address': new FormControl('',
          [Validators.required, Validators.minLength(4), Validators.maxLength(40), Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/))]),
        'input-value-addressDetail': new FormControl(''),
      });
    }

    // this.options = this.parametersService.getSetting(OpEnum.CITY_LIST);
    this.contactInfo = (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline)
      ? this.abreCuentasService.getContactInfo()
      : this.abreCuentasService.getContactInfoSecondHeadline();
    if (this.contactInfo.address !== undefined && this.contactInfo.address.city !== undefined) {
      this.selectedCity = this.contactInfo.address.city;
      this.selected_district = this.selectedCity.district_id;
      this.selectedHousingType = this.contactInfo.address.housingType !== undefined ?
        this.contactInfo.address.housingType : {
          housingId: '',
          description: '',
        };
      this.selectedStratum = this.contactInfo.address.stratum !== undefined ? this.contactInfo.address.stratum : '';
      this.contactInfo.mobile_number = this.contactInfo.mobile_number !== undefined ? this.contactInfo.mobile_number : '';
      return;
    }

    this.contactInfo.address = {
      city: new CityModel(),
      address: '',
      detail: '',
      addressInput: '',
      stratum: '',
      housingType: new HousingTypeModel(),
    };
    this.selectedCity = {
      city_code: '',
      country_code: '',
      province_code: 0,
      description: '',
    };
    this.selectedHousingType = {
      housingId: '',
      description: '',
    };
    this.selectedStratum = '';
  }

  ngAfterContentInit() {
    const controladdress = this.formGroup.controls['input-value-address'] as FormControl;
    const controladdressdetail = this.formGroup.controls['input-value-addressDetail'] as FormControl;
    controladdress.setValue(this.contactInfo.address.addressInput);
    controladdressdetail.setValue(this.contactInfo.address.detail);
  }

  /**
   * Evento de cambio de dirección
   *
   * *Summary Address entry change event, error validation*
   */
  reactiveInputChangeAddress() {
    const controladdress = this.formGroup.controls['input-value-address'] as FormControl;
    controladdress.setValue(controladdress.value.replace(/[^A-Za-z0-9\s#\-.]/g, '').replace(/\s{2,}/g, ' '));
    this.setContactInfo();
  }

  /**
   * Normalizar dirección
   *
   * *Summary normalize address*
   * @returns {string}
   */
  validateAddress(): string {
    const controladdress = this.formGroup.controls['input-value-address'] as FormControl;
    const controladdressdetail = this.formGroup.controls['input-value-addressDetail'] as FormControl;
    return this.stringHelperService.normalizeAddress(controladdress.value, controladdressdetail.value);
  }

  /**
   * event mail entry change, error validation
   */
  next() {
    this.setContactInfo();
    const productSelected = this.abreCuentasService.getproductSelected();
    if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      this.navigationService.nextStep('200');
      return;
    }

    this.captureService.sendProspectOccupationUbicationInfo(this.contactInfo).then(
      async () => {
        if (this.abreCuentasService.viewOptionMultiProduct ||
          productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
          await this.incomesService.callIncomes()
          .then(
            response => {
              if (response === '200') {
                if (this.abreCuentasService.getPostlogin() &&
                  !this.validationHelperService.validateMailPhone()) {
                  this.navigationService.navigateToGeneralInformation('512');
                } else {
                  this.switchCode();
                }
              }
            },
          );
        } else {
          this.navigationService.nextStep('200');
        }
      },
    ).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  /**
   * Summary Event for select a option for list selected, and set value in Input
   * @param option
   */
  selectOptionHousing(event: any) {
    if (event.value) {
      this.selectedHousingType = { housingId: event.value.id, description: event.value.name };
      this.setContactInfo();
    } else {
      this.selectedHousingType = { housingId: '', description: '' };
    }
  }

  /**
   * Summary Event for select a option for list selected, and set value in Input
   * @param option
   */
  selectOptionStratum(event: any) {
    if (event.value) {
      this.selectedStratum = event.value.name;
      this.setContactInfo();
    } else {
      this.selectedStratum = '';
    }
  }

  /**
   * Summary Event for select a option for list selected, and set value in Input
   * @param option
   */
  selectOption(event: any) {
    if (event.value) {
      this.selectedCity = this.options.find(e => e.city_code === event.value.city_code && e.province_code === event.value.province_code);
      this.setContactInfo();
    } else {
      this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
    }
  }

  /**
   * charge in contactModel the form data
   */
  setContactInfo() {
    this.contactInfo = {
      mobile_number: this.contactInfo.mobile_number !== undefined ? this.contactInfo.mobile_number : '',
      email: this.contactInfo.email,
      employment_number: '',
      address: {
        city: this.selectedCity,
        addressInput: this.formGroup.controls['input-value-address'].value,
        detail: this.formGroup.controls['input-value-addressDetail'].value,
        address: this.validateAddress(),
        stratum: this.selectedStratum !== undefined ? this.selectedStratum : '',
        housingType: {
          housingId: this.selectedHousingType !== undefined ? this.selectedHousingType.housingId : '',
          description: this.selectedHousingType !== undefined ? this.selectedHousingType.description : '',
        },
      },
    };
    this.has_second_headline ? this.abreCuentasService.setContactInfoSecondHeadline(this.contactInfo)
      : this.abreCuentasService.setContactInfo(this.contactInfo);

  }

  switchCode() {
    switch (this.abreCuentasService.getOccupationSelected().id) {
      case 1:
        this.navigationService.nextStep('201');
        break;
      case 2:
        this.navigationService.nextStep('202');
        break;
      case 5:
        this.navigationService.nextStep('200');
        break;
      default:
        this.navigationService.nextStep();
        break;
    }
  }

  async getCitys(provence_id: string) {
    await this.requestService.cityBranches(provence_id).then(responseU => {
      this.city_option = responseU.body;
      this.options = this.city_option.map(data => {
        const codeDaneUbication = data.code_dane;
        const codeDanelength = codeDaneUbication.length - 3;
        return {
          city_code: codeDaneUbication.substring(codeDanelength),
          province_code: +codeDaneUbication.substring(0, codeDanelength),
          description: data.city,
          district_id: data.district.district_id,
        };
      },
        );
    });
  }

  selectOptionProvidence(event) {
    const valueUbication: string = event.value;
    if (valueUbication && valueUbication.trim() !== '') {
      this.selected_district = valueUbication;
      this.getCitys(valueUbication);
    } else {
      this.city_option = undefined;
      this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
      this.selected_district = undefined;
    }
  }
}
